import React, { useState, useEffect, lazy } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import LocationContext from './context/location';
import { AnimatePresence, motion } from 'framer-motion';

import allArticles from './content'

import Home from "./pages/home";
import NotFound from "./pages/not-found";
import Article from "./pages/article"
const About = lazy(() => import("./pages/about"))
const Imprint = lazy(() => import("./pages/imprint"))
const DataPrivacy = lazy(() => import("./pages/data-privacy"))


import Header from "../src/components/header";
import Cookies from "../src/components/cookies";

const MotionHeader = motion(Header)

export const Routes = () => {
	const [ isArticle, setIsArticle ] = useState(false)
	const [ showHeader, setShowHeader] = useState(false)
	const [ gridView, setGridView ] = useState('grid')
	const location = useLocation()
	const [ headerState, setHeaderState ] = useState({
		buttons: true,
		closeLink: false,
		aboutUsLink: true
	})

	useEffect(() => {
		// check wether slug matches an article
		const url = location.pathname.split('/')[1];
		const slugs = [];
		allArticles.map(a => slugs.push(a.meta.slug));
		setIsArticle(slugs.includes(url))
	}, [location])

	const onSetIntroAnimationComplete = (value) => {
		setShowHeader(value)
	}

	const onSetHeaderState = (args) => {
		setHeaderState(prevState => ({ 
			...prevState,
			...args
		}))
	}

	const onShowHeader = () => {
		setShowHeader(true)
	}

	const onSetGridView = (value) => {
		setGridView(value)
	}

	const HeaderTransitions = {
		out: {
			opacity: 0,
			transition: {duration: 0.4, type: 'Tween'}
		},
		in: {
			opacity: 1,
			transition: {duration: 0.4, type: 'Spring'}
		},
		exit: {
			opacity: 0,
			transition: {duration: 0.4, type: 'Tween'}
		}
	}

  return (
		<LocationContext.Provider value={{ onIntroAnimationComplete: onSetIntroAnimationComplete, onSetGridView: onSetGridView}}>
			{ (!isArticle && showHeader) &&
				<MotionHeader
					closeLink={headerState.closeLink}
					aboutUsLink={headerState.aboutUsLink}
					buttons={headerState.buttons}
					initial="out" animate="in" exit="exit" out="out" variants={HeaderTransitions}
				></MotionHeader>
			}
			<AnimatePresence>
				<Switch location={location} key={location.key}>
					<Route exact path="/" render={() => <Home gridView={gridView} introAnimationComplete={showHeader} showHeader={() => onShowHeader()} setHeaderState={(args) => onSetHeaderState(args)} /> } />
					<Route path="/ueber-uns" render={() => <About showHeader={() => onShowHeader()} setHeaderState={(args) => onSetHeaderState(args)} />} />
					<Route path="/impressum" render={() => <Imprint showHeader={() => onShowHeader()} setHeaderState={(args) => onSetHeaderState(args)} />} />
					<Route path="/datenschutz" render={() => <DataPrivacy showHeader={() => onShowHeader()} setHeaderState={(args) => onSetHeaderState(args)} />} />
					<Route path="/:name" component={Article} />
					<Route component={NotFound} />
				</Switch>
			</AnimatePresence>
		</LocationContext.Provider>
  );
};
